// extracted by mini-css-extract-plugin
module.exports = {"replicaList":"Salvage_replicaList-2nQ2e","replica":"Salvage_replica-ozf1Z","selected":"Salvage_selected-2fcef","header":"Salvage_header-1oOOv","icon":"Salvage_icon-6qI7X"};